import {
  IconButton,
  Typography,
  Box
} from "@mui/material";
import {
  Edit,
  Delete,
  Add,
  PushPin,
  ForwardToInbox
} from "@mui/icons-material";
import { getArticleShareHTML, getEmailDistributionList, sendArticle } from "../data/index.js";
import { default as bus } from '../../utils/EventBus.js';
import EventNames from '../../utils/EventNames.js'
import HubEventNames from '../EventNames.js'
import RoleContext from '../../auth/RoleContext.js'
import { useContext } from "react";
import { Stage } from "../../config/config.js";
import { getSiteConfig } from '../../community/siteProvider'

const startPageLoading = () => bus.emit(EventNames.START_PAGE_LOADING)
const stopPageLoading = () => bus.emit(EventNames.STOP_PAGE_LOADING)

export default function ArticleControls(props = {}) {
  const {
    hovering,
    onClickAdd,
    onClickEdit,
    onClickDelete,
    layout = "horizontal",
    isDraft,
    showAdd,
    isPinned,
    article
  } = props;

  const siteConfig = getSiteConfig()
  const roleDetails = useContext(RoleContext)

  const onSendArticleShare = async (articleShareHTML, emailList, subject, shareId, siteConfig) => {
    try {
      await sendArticle(subject, emailList, articleShareHTML, shareId, siteConfig)
      bus.emit(EventNames.ALERT, {
        style: 'success',
        text: 'Article shared!',
        duration: 3000,
        showClose: true
      })
    } catch(err) {
      bus.emit(EventNames.ALERT, {
        style: 'error',
        text: err.message,
        duration: 3000,
        showClose: true
      })
    }
  }

  const handleShareConfirm = async (subject, recipients) => {
    startPageLoading()
    try {
      const shareId = crypto.randomUUID()
      const link = `${window.location}/${article.guid}`
      const articleShareHTML = await getArticleShareHTML(article.guid, recipients, link)

      const emailList = await getEmailDistributionList(recipients)
      bus.emit(HubEventNames.OPEN_SHARE_ARTICLE_PREVIEW_DIALOG, {
        onSend: async () => {
          startPageLoading()
          await onSendArticleShare(articleShareHTML, emailList, subject, shareId, siteConfig)
        },
        onSendTest: async () => {
          startPageLoading()
          await onSendArticleShare(articleShareHTML, [], `**TEST** - ${subject}`, shareId, siteConfig)
        },
        onClose: stopPageLoading,
        subject,
        emailHTML: articleShareHTML,
        emailList,
      })
    } catch(err) {
      bus.emit(EventNames.ALERT, {
        style: 'error',
        text: err.message,
        duration: 3000,
        showClose: true
      })
    } finally {
      stopPageLoading()
    }
  };

  const openShareDialog = (event) => {
    event.stopPropagation();
    event.preventDefault();
    bus.emit(HubEventNames.OPEN_SHARE_ARTICLE_DIALOG, {
      subject: article.title,
      onConfirm: handleShareConfirm
    })
  };

  return (
    <>
      {/* CONTROLS */}
      <Box
        sx={{
          zIndex: 5,
          display: "flex",
          flexDirection: layout === "vertical" ? "column" : "row",
          alignItems: layout === "vertical" ? "flex-end" : "flex-start",
          gap: 1
        }}
        className="top-controls"
      >
        {isPinned && (
          <Box className="pinned-indicator">
            <PushPin />
          </Box>
        )}

        {isDraft && (
          <Box className="draft-indicator">
            <Typography variant="body2">DRAFT</Typography>
          </Box>
        )}

        <Box
          sx={{ display: hovering ? "flex" : "none" }}
          className="edit-delete-icons"
        >
          <div className="article-controls-backdrop">
            {showAdd && (
              <IconButton
                onMouseDown={(e) => e.stopPropagation()}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  onClickAdd();
                }}
                size="small"
                className="icon-button"
              >
                <Add />
              </IconButton>
            )}

            {roleDetails.isSiteManager() && !article.newsWebUrl && <IconButton
              onMouseDown={(e) => e.stopPropagation()}
              onClick={openShareDialog}
              size="small"
              className="icon-button"
            >
              <ForwardToInbox />
            </IconButton>}

            <IconButton
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onClickEdit();
              }}
              size="small"
              className="icon-button"
            >
              <Edit />
            </IconButton>

            <IconButton
              onMouseDown={(e) => e.stopPropagation()}
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                onClickDelete();
              }}
              size="small"
              className="icon-button"
            >
              <Delete />
            </IconButton>
          </div>
        </Box>
      </Box>

      {/* SHARE DIALOG */}
      {/* <ShareArticleDialog
        open={shareOpen}
        onClose={closeShareDialog}
        onConfirm={handleShareConfirm}
      />

      <SharePreviewDialog
        open={sharePreviewOpen}
        onClose={closeSharePreviewDialog}
        onSend={onSendArticleShare}
        emailHTML={emailHTML}
        recipients={emailRecipients}
      /> */}
    </>
  );
}